import { render } from "./ProgramaSemilleroArea.vue?vue&type=template&id=9e45d1e8"
import script from "./ProgramaSemilleroArea.vue?vue&type=script&lang=js"
export * from "./ProgramaSemilleroArea.vue?vue&type=script&lang=js"

import "./ProgramaSemilleroArea.vue?vue&type=style&index=0&id=9e45d1e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__